module.exports = "\r\n.es {\r\n    width:45px;\r\n    height:23px;\r\n}\r\n\r\n.selectpicker {\r\n\tfont-size: 18px !important;\r\n\tfont-weight: bold !important;\r\n\ttext-decoration: none !important;\r\n\tmargin: 0px;\r\n\tpadding: 23px;\r\n\tfloat: left;\r\n\twidth: 100%;\r\n\toutline: none !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main